import React, { Component } from "react";
import { connect } from "react-redux";
import uuid from "uuid";

import {
  setRecipientsListFilterName,
  setRecipientsPageSize,
  setRecipientsPaginationPage,
} from "actions";
import _ from "i18n";
import TTPPaginator from "common/list/TTPPaginator";
import SearchBox from "common/filter/SearchBox";
import PageSize from "common/list/PageSize";
import NotFound from "notFound/NotFound";
import "react-input-range/lib/css/index.css";
import {
  LIST_PAGE_SIZES_UA_RECIPIENTS_LIST,
  UA_RECIPIENT_ATTRIBUTE,
} from "../../../../config/Common";
import { setCurrentEmailCampaignData } from "../../../../actions/actions/currentCampaign";
import CheckBoxBtn from "../../../common/CheckBoxBtn";
import { InfoBar } from "../notifications/InfoBar";
import { ucFirst } from "../../../../services/common";

@connect((store) => {
  return {
    recipients: store.campaigns.recipients,
    commitmentScoreRange: store.currentCampaign.email.commitmentScoreRange,
    searchValue: store.campaigns.recipients.filter.name,
    recipientType: store.currentCampaign.email.recipientType,
    paginationPage: store.campaigns.recipients.filter.paginationPage,
    allowedGroups: store.currentCampaign.email.allowedGroups,
    deniedGroups: store.currentCampaign.email.deniedGroups,
    manualRecipients: store.currentCampaign.email.manualRecipients,
    liteRecipients: store.currentCampaign.email.liteRecipients,
    personalizedRecipients: store.currentCampaign.email.personalizedRecipients,
    eliminatedRecipients: store.currentCampaign.email.eliminatedRecipients,
    pageSize: store.campaigns.recipients.filter.pageSize,
    nbOfRecipients: store.currentCampaign.email.nbOfRecipients,
  };
})
export default class Recipients extends Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      recipientType,
      paginationPage,
      recipientsTab,
      recipients,
      allowedGroups,
      deniedGroups,
      dispatch,
      plan,
      liteRecipients,
      manualRecipients,
    } = this.props;

    const hasItems = recipientsTab.some(
      (recipient) => recipient.recipientType === recipientType,
    );
    let itemsResult = [];
    let recipientCounts = 0;

    if (prevProps.recipients?.items !== recipients?.items) {
      const updatedRecipientsTab = hasItems
        ? recipientsTab.map((recipient) => {
            if (recipient.recipientType === recipientType) {
              return {
                ...recipient,
                items: recipients?.items || [],
                paginationPage,
                count: recipients?.recipientsTotalCount || 0,
                deniedGroups: recipient.deniedGroups,
                allowedGroups: recipient.allowedGroups,
              };
            }
            return recipient;
          })
        : [
            ...recipientsTab,
            {
              recipientType,
              items: recipients?.items || [],
              paginationPage,
              count: recipients?.recipientsTotalCount || 0,
              deniedGroups: deniedGroups,
              allowedGroups: allowedGroups,
            },
          ];
      itemsResult = recipients?.items || [];
      recipientCounts = recipients?.recipientsTotalCount || [];
      this.props.handleChangeRecipientTab(updatedRecipientsTab);

      const matchingRecipient = recipientsTab.find(
        (recipient) => recipient.recipientType === recipientType,
      );

      let selectAllRecipientValue = false;
      let selectedPageValue = false;
      if (matchingRecipient) {
        selectAllRecipientValue = matchingRecipient.selectAllRecipient;
        selectedPageValue = matchingRecipient.selectedPage;
      }
      this.props.handleChangeItemsRecipients(
        itemsResult,
        recipientCounts,
        selectAllRecipientValue,
        selectedPageValue,
      );
    }
    if (recipientType && prevProps.recipientType !== recipientType) {
      const matchingRecipient = recipientsTab.find(
        (recipient) => recipient.recipientType === recipientType,
      );

      if (matchingRecipient) {
        const {
          items,
          count,
          paginationPage,
          liteRecipients,
          personalizedRecipients,
          eliminatedRecipients,
          selectAllRecipient,
          selectedPage,
        } = matchingRecipient;
        itemsResult = items;
        recipientCounts = count;
        dispatch(setRecipientsPaginationPage(paginationPage));
        liteRecipients &&
          dispatch(
            setCurrentEmailCampaignData({
              liteRecipients: liteRecipients,
            }),
          );
        personalizedRecipients &&
          dispatch(
            setCurrentEmailCampaignData({
              personalizedRecipients: personalizedRecipients,
            }),
          );
        eliminatedRecipients &&
          dispatch(
            setCurrentEmailCampaignData({
              eliminatedRecipients: eliminatedRecipients,
            }),
          );
        this.props.handleChangeItemsRecipients(
          itemsResult,
          recipientCounts,
          selectAllRecipient,
          selectedPage,
        );
      } else {
        dispatch(setRecipientsPaginationPage(1));
      }
    }
    if (this.props.recipientsItems !== prevProps.recipientsItems) {
      this.props.updateSelectAllState(this.props.recipientsItems);
    }
    if (recipientsTab !== prevProps.recipientsTab) {
      const isLitePlan = plan === "LITE";
      const isPersonalizedPlan = plan === "PERSONALIZED";
      const isStandardPlan = plan === "STANDARD";

      let totalOfRecipients = isLitePlan
        ? (liteRecipients?.length || 0) + (manualRecipients?.length || 0)
        : isPersonalizedPlan || isStandardPlan
          ? recipientsTab.reduce((count, recipient) => {
              if (recipient && recipient.selectAllRecipient) {
                const eliminatedRecipientCount =
                  recipient.eliminatedRecipients?.[recipient.recipientType]
                    ?.length || 0;
                count = count + (recipient.count - eliminatedRecipientCount);
              } else if (recipient) {
                const personalizedRecipientCount =
                  recipient.personalizedRecipients?.[recipient.recipientType]
                    ?.length || 0;
                count = count + personalizedRecipientCount;
              }
              return count;
            }, 0) + (manualRecipients?.length || 0)
          : 0;
      dispatch(
        setCurrentEmailCampaignData({
          nbOfRecipients: totalOfRecipients,
        }),
      );
    }
  }

  handleSearch = (value) => {
    const { dispatch } = this.props;
    dispatch(setRecipientsListFilterName(value));
  };

  handleRecipientListPageClick(data) {
    const { dispatch } = this.props;
    let selectedPage = data.selected;
    dispatch(setRecipientsPaginationPage(selectedPage + 1));
  }

  handleSelectRecipientListPageSize = (pageSize) => {
    const { dispatch } = this.props;
    dispatch(setRecipientsPageSize(pageSize));
  };

  shouldComponentUpdate(nextProps, nextState) {
    let { recipients, recipientsItems } = nextProps;

    if (recipientsItems?.length !== this.props.recipientsItems?.length) {
      window.dispatchEvent(new Event("resize"));
    }
    // Don't update component during ajax fetch new data process
    let condition1 = !recipients.fetching && recipients.fetched;
    // Result not found
    let condition2 = !recipients.items?.length || !recipients.error;

    return condition1 || condition2;
  }

  getRecipientName(recipient) {
    let { recipientType } = this.props;
    const attributes = UA_RECIPIENT_ATTRIBUTE[recipientType];

    let fullName = `${recipient[attributes.lastName] || ""} ${
      attributes.firstName ? recipient[attributes.firstName] || "" : ""
    }`;

    return fullName || "--";
  }

  getRecipientEmail(recipient) {
    let { recipientType } = this.props;

    const attributes = UA_RECIPIENT_ATTRIBUTE[recipientType];

    return recipient[attributes.email] || recipient["mainEmail"] || "";
  }

  getRecipientOrganizationName(recipient) {
    let { recipientType } = this.props;

    const attributes = UA_RECIPIENT_ATTRIBUTE[recipientType];

    return (
      recipient[attributes.organizationName] || recipient["folderName"] || ""
    );
  }

  getRecipientGroups(recipient) {
    let { recipientType } = this.props;
    const attributes = UA_RECIPIENT_ATTRIBUTE[recipientType];

    if (
      recipient[attributes.groups] &&
      Array.isArray(recipient[attributes.groups])
    ) {
      const groupNames = recipient[attributes.groups].map(
        (group) => group.name,
      );
      return groupNames.join(", ");
    }

    return "";
  }

  updateSelectAllState = (targets) => {
    const { liteRecipients } = this.props;

    const recipientEmails = targets.map((recipient) => recipient.mainEmail);
    const isAllSelected = recipientEmails.every((email) =>
      liteRecipients.some((recipient) => recipient.email === email),
    );

    return isAllSelected;
  };

  render() {
    const {
      recipients,
      recipientType,
      searchValue,
      liteRecipients,
      selectAll,
      recipientsItems,
      count,
      selectedPage,
      plan,
      selectAllRecipient,
      personalizedRecipients,
      eliminatedRecipients,
      pageSize,
    } = this.props;

    if (!recipientType || recipientType === "MANUAL") {
      return null;
    }
    let notfoundBlock = <NotFound />;

    let targets = recipientsItems?.map((recipient) =>
      recipient.user && typeof recipient.user == "object"
        ? recipient.user
        : recipient,
    );
    const isLitePlan = plan === "LITE";
    const isPersonalizedPlan = plan === "PERSONALIZED";
    const isStandardPlan = plan === "STANDARD";

    return (
      <div className="row">
        <div className="small-12 columns list-filter__bar">
          <span className="tab-label">
            {_("result_number")} :
            <span className="required">{count ? count : 0}</span>
          </span>
          {(isPersonalizedPlan || isStandardPlan) && (
            <div className="check_select">
              <CheckBoxBtn
                checked={selectAllRecipient}
                onChange={() => {
                  this.props.handleChangSelectAllRecipient();
                }}
                id="select-all"
              />
              <span>
                {!selectAllRecipient ? _("selectAll") : _("deselect")}
              </span>
            </div>
          )}

          <SearchBox
            value={searchValue}
            onChange={this.handleSearch}
            cssClass="small-5"
          />
          <PageSize
            pageSize={recipients.filter.pageSize}
            onChange={this.handleSelectRecipientListPageSize.bind(this)}
            listPageSize={LIST_PAGE_SIZES_UA_RECIPIENTS_LIST}
          />
        </div>
        {(selectedPage || selectAllRecipient) && count > 20 && (
          <InfoBar
            message={
              _("the") +
              " " +
              count +
              " " +
              _("desc_selection") +
              " " +
              ucFirst(_(recipientType)).replace(/_/g, " ") +
              " " +
              _("its_selected")
            }
            description={
              !selectedPage
                ? _("desc_selection_1") +
                  " " +
                  pageSize +
                  " " +
                  _("desc_selection_2")
                : _("clear_selection")
            }
            changePersonalizedRecipients={async () => {
              if (!selectedPage) {
                await this.props.changePersonalizedRecipients(targets, true);
              } else {
                await this.props.clearSelection();
              }
              this.props.updateRecipientsTab();
            }}
          />
        )}

        {!recipientsItems || recipientsItems?.length === 0 ? (
          notfoundBlock
        ) : (
          <div className="row small-12">
            <div className="columns small-12">
              <div className="ttp-datatable p-l-xs">
                <div className="row ttp-datatable__header">
                  <div
                    className={
                      recipientType === "CONTACT_CLIENT"
                        ? "small-3"
                        : recipientType === "CONTACT"
                          ? "small-4"
                          : "small-5"
                    }
                    style={{ display: "flex" }}
                  >
                    {isLitePlan && (
                      <CheckBoxBtn
                        checked={selectAll}
                        onChange={() => {
                          this.props.changeLiteRecipients(targets, true);
                        }}
                        id="select-all"
                      />
                    )}

                    {_("name")}
                  </div>
                  <div
                    className={
                      recipientType === "CONTACT_CLIENT"
                        ? "small-3"
                        : recipientType === "CONTACT"
                          ? "small-4"
                          : "small-5"
                    }
                  >
                    {_("email")}
                  </div>
                  {recipientType === "CONTACT_CLIENT" && (
                    <div className="small-3">{_("organization")}</div>
                  )}
                  {(recipientType === "CONTACT" ||
                    recipientType === "CONTACT_CLIENT") && (
                    <div
                      className={
                        recipientType === "CONTACT_CLIENT"
                          ? "small-2"
                          : "small-3"
                      }
                    >
                      {_("groups")}
                    </div>
                  )}
                </div>
                {targets?.map((target, i) => {
                  return (
                    <div key={uuid()} className="row ttp-datatable__row">
                      <div
                        className={
                          recipientType === "CONTACT_CLIENT"
                            ? "small-3"
                            : recipientType === "CONTACT"
                              ? "small-4"
                              : "small-5"
                        }
                        style={{ display: "flex" }}
                      >
                        <CheckBoxBtn
                          checked={
                            isLitePlan
                              ? liteRecipients.some(
                                  (recipient) =>
                                    recipient.email ===
                                    this.getRecipientEmail(target),
                                )
                              : (isPersonalizedPlan || isStandardPlan) &&
                                (personalizedRecipients[recipientType] &&
                                personalizedRecipients[recipientType]?.length >
                                  0
                                  ? personalizedRecipients[recipientType]
                                      .filter(
                                        (recipient) =>
                                          !eliminatedRecipients[
                                            recipientType
                                          ]?.includes(recipient),
                                      )
                                      .some(
                                        (recipient) =>
                                          recipient.email ===
                                          this.getRecipientEmail(target),
                                      )
                                  : eliminatedRecipients[recipientType] &&
                                      eliminatedRecipients[recipientType]
                                        ?.length > 0
                                    ? !eliminatedRecipients[recipientType].some(
                                        (recipient) =>
                                          recipient.email ===
                                          this.getRecipientEmail(target),
                                      )
                                    : selectAllRecipient)
                          }
                          onChange={async () => {
                            if (isLitePlan) {
                              await this.props.changeLiteRecipients(target);
                            } else {
                              await this.props.changePersonalizedRecipients(
                                target,
                              );
                            }
                            this.props.updateRecipientsTab();
                          }}
                          id={i}
                        />
                        {this.getRecipientName(target)}
                      </div>
                      <div
                        className={
                          recipientType === "CONTACT_CLIENT"
                            ? "small-3 email-target"
                            : recipientType === "CONTACT"
                              ? "small-4 email-target"
                              : "small-5 email-target"
                        }
                      >
                        {this.getRecipientEmail(target)}
                      </div>
                      {recipientType === "CONTACT_CLIENT" && (
                        <div className="small-3">
                          {this.getRecipientOrganizationName(target)}
                        </div>
                      )}
                      {(recipientType === "CONTACT_CLIENT" ||
                        recipientType === "CONTACT") && (
                        <div
                          className={
                            recipientType === "CONTACT_CLIENT"
                              ? "small-2 groups-name"
                              : "small-3 groups-name"
                          }
                        >
                          {this.getRecipientGroups(target)}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="small-12">
              <TTPPaginator
                onPageChange={this.handleRecipientListPageClick.bind(this)}
                pageSize={recipients.filter.pageSize}
                nbResult={count}
                paginationPage={recipients.filter.paginationPage}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}
